<h1>{{ title }}</h1>
<p class="typog-body-large">{{ body }}</p>
